export default class InstituicaoEnsino {
    constructor({
      nome,
      cnpj,
      razaoSocial,
      municipio,
      uf,
    }) {
      this.nome = nome;
      this.cnpj = cnpj;
      this.razaoSocial = razaoSocial;
      this.municipio = municipio;
      this.uf = uf;
    }
  }